import { gsap } from 'gsap/all'
import { getColorMode, hexToRgb } from 'helpers'

export const theme = {
  el: {
    featuredCardBackgrounds: document.querySelectorAll<HTMLElement>('.featured-card__background'),
    header: document.querySelector<HTMLElement>('.header'),
    pages: document.querySelectorAll<HTMLElement>('.brand-page, .product-page'),
  },

  init: () => {
    if (theme.el.featuredCardBackgrounds[0]) {
      theme.el.featuredCardBackgrounds.forEach((featuredCardBackground) => {
        theme.setBackground(featuredCardBackground, featuredCardBackground)
        theme.setTheme(featuredCardBackground, featuredCardBackground.parentElement)
      })
    }

    if (theme.el.pages[0]) {
      theme.el.pages.forEach((page) => {
        theme.setBackground(page, document.body)
        theme.setTheme(page, document.body)
        theme.setTheme(page, page)
      })
    }
  },

  setBackground: (sourceEl, targetEl) => {
    gsap.set(targetEl, {
      background: `linear-gradient(180deg, ${sourceEl.dataset.colorTop} 0%, ${sourceEl.dataset.colorBottom} 100%)`,
    })
  },

  setTheme: (sourceEl, targetEl) => {
    const topColor = sourceEl.dataset.colorTop
    const bottomColor = sourceEl.dataset.colorBottom

    if (!topColor || !bottomColor) return

    const colorTopMode = getColorMode(hexToRgb(topColor))
    const colorBottomMode = getColorMode(hexToRgb(bottomColor))

    if (colorTopMode === 'dark' || colorBottomMode === 'dark') {
      targetEl.dataset.theme = 'dark'
    }
  },

  setHeroBackgroundsAndColors: (hero) => {
    const backgroundSlides = hero.querySelectorAll('.hero__slide--background')
    const textSlides = hero.querySelectorAll('.hero__slide--text')

    backgroundSlides.forEach((backgroundSlide, index) => {
      const colorTop = backgroundSlide.dataset.colorTop
      const colorBottom = backgroundSlide.dataset.colorBottom
      const elBackground = backgroundSlide.firstElementChild
      const elBackgroundTop = elBackground.firstElementChild

      gsap.set(elBackground, {
        background: `linear-gradient(180deg, ${colorTop} 0%, ${colorBottom} 100%)`,
      })

      gsap.set(elBackgroundTop, {
        background: colorTop,
      })

      const colorTopMode = getColorMode(hexToRgb(colorTop))
      const colorBottomMode = getColorMode(hexToRgb(colorBottom))

      if (colorTopMode === 'dark' || colorBottomMode === 'dark') {
        backgroundSlide.dataset.theme = 'dark'
        textSlides[index].dataset.theme = 'dark'
      }
    })
  },
}
